import axios from '../axios'
import config from "@/utils/global.js";
/* 
 * 字典管理模块
 */


// 保存
export const save = (data) => {
    return axios({
        url: config.zuul+'/xyj-admin/w/dict/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: config.zuul+'/xyj-admin/w/dict/delete',
        method: 'post',
        data
    })
}
// 分页查询
export const findPage = (data) => {
    return axios({
        url: config.zuul+'/xyj-admin/r/dict/findPage',
        method: 'post',
        data
    })
}
// 保存
export const save1 = (data) => {
    return axios({
        url: config.zuul+'/xyj-admin/w/partCompany/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete1 = (data) => {
    return axios({
        url: config.zuul+'/xyj-admin/w/partCompany/delete',
        method: 'post',
        data
    })
}
// 分页查询
export const findPage1 = (data) => {
    return axios({
        url: config.zuul+'/xyj-admin/r/partCompany/findPage',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/dict.js